import type { FaireProductEntity } from "../../entity_types/product";

export const p_8vumepf6wk: FaireProductEntity = {
  token: "p_8vumepf6wk",
  type: "product",
  name: "Get Clean! No-Foam Shampoo",
  brandToken: "b_eerxm9hive",
  brandName: "Original Moxie",
  imageUrl:
    "https://cdn.faire.com/fastly/23a008d402e0304dab16b0bbb22b1e52a0d498e906a9d5957ac97290a85eebc9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eba1ae30d5175cf7daa5692928e97618205ef678eada78e049fdc7f53740fa56.jpeg",
    "https://cdn.faire.com/fastly/0514b644ce98f31c637b5af82cf8785977926e8280996dc659a4f1071bc92006.png",
    "https://cdn.faire.com/fastly/ff71fa5d80f1907787f56cb46af272c9bc8cec97a0b6bdb4da36c5199fd5faaa.png",
    "https://cdn.faire.com/fastly/ce9fabfcec40c638d72b73c1253f845cd0c9c2344f3557ec66c346f661c26c07.png",
    "https://cdn.faire.com/fastly/3ea8bd4e8d3b36a2586a8d46d94ae22f6e0a1492a5ca3c33d91c566a00922610.png",
  ],
  priceDollars: 11,
  description:
    "Break your Foam Addiction and discover your hair as it was meant to be! Our natural, sulfate-free shampoo removes dirt and excess oil without disturbing your scalp’s natural balance, leaving your hair moisturized and clean. Turmeric calms inflammation and combats bacteria, supporting a healthy scalp biome and helping your hair to thrive.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:49.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
